import {Injectable} from "@angular/core";
import {GridLayoutService} from "@irb-common/interfaces/grid-layout.service";
import {UtilityService} from "@irb-common/services/utility.service";
import {
  ComAutomatedRebalancingComponent
} from "@irb/irb-editors/editor-portfolio/com-automated-rebalancing/com-automated-rebalancing.component";
import {DeleteHeaderComponent} from "@irb-common/components/grid/renderers/delete.header.component";
import {DropdownFilterRendererComponent} from "@irb-common/components/grid/renderers/dropdown-filter.cell.component";
import {DropdownSearchRendererComponent} from "@irb-common/components/grid/renderers/dropdown-search.cell.component";
import {CallToActionCellComponent} from "@irb-common/components/grid/renderers/calltoaction.cell.component";
import {TruncateTooltipCellComponent} from "@irb-common/components/grid/renderers/truncatetooltip.cell.component";

@Injectable({
  providedIn: 'root'
})
export class ComAutomatedRebalancingGridLayoutService implements GridLayoutService<ComAutomatedRebalancingComponent> {
  altSecurityName: any;
  typeRestriction: string[] = [];

  constructor(private util: UtilityService) {
  }
  getFrameworkComponents() {
    return {
      "DeleteHeaderComponent": DeleteHeaderComponent,
      "DropdownFilterRendererComponent": DropdownFilterRendererComponent,
      "DropdownSearchRendererComponent": DropdownSearchRendererComponent,
      "CallToActionCellComponent": CallToActionCellComponent,
      "TruncateTooltipCellComponent": TruncateTooltipCellComponent
    };
  }
  displayRebalanceName(params: any) {
    return params?.data?.analysisName;
  }
  displayNumberOfTrades(params: any) {
    return params?.data?.ordersTotal || '0';
  }
  displayStatus(params: any) {
    const approveStatus = params?.data?.approveStatus;
    const outcome = params?.data?.outcome;
    if (outcome === 'UNRESOLVED' && approveStatus === 'IGNORED') { return 'Ignored';}
    if (outcome === 'ORDERS' && approveStatus === 'IGNORED') { return 'Ignored';}
    if (outcome === 'REBALANCE' && approveStatus === 'PROCESSING') { return 'Processing';}
    if (outcome === 'ORDERS' && approveStatus === 'REFUSED') { return 'Refused';}
    if (outcome === 'ORDERS' && approveStatus === 'PENDING') { return 'Pending';}
    if (outcome === 'ORDERS' && approveStatus === 'APPROVED') { return 'Approved';}
    if (outcome === 'UNRESOLVED' && approveStatus === 'NA') { return 'Unresolved';}
    if (outcome === 'NO_ORDERS' && approveStatus === 'IGNORED') { return 'Ignored';}
    if (outcome === 'SKIPPED' && approveStatus === 'SKIPPED') { return 'Skipped';}
    if (outcome === 'NO_ORDERS' && approveStatus === 'REFUSED') { return 'Refused';}
    if (outcome === 'UNRESOLVED' && approveStatus === 'FAILED') { return 'Failed';}
    if (outcome === 'UNRESOLVED' && approveStatus === 'APPROVED') { return 'Approved';}
    if (outcome === 'NO_ORDERS' && approveStatus === 'APPROVED') { return 'Approved';}
    if (outcome === 'NO_ORDERS' && approveStatus === 'NA') { return 'No Orders';}
    if (outcome === 'ORDERS' && approveStatus === 'NA') { return 'NA';}
    return outcome;
  }
  displayRebalanceID(params: any) {
    return params?.data?.rbRsltId;
  }
  displayRebalanceType(params: any) {
    return params?.data?.analysisTypeDesc;
  }
  displayRebalanceCompletedOn(params: any) {
    const completedDate = params?.data?.completionDate;
    const self = params.context.componentParent.gls;
    return self.convertDateAndTimeToET(completedDate);
  }
  getColumnDefs(parent: ComAutomatedRebalancingComponent): Array<any> {
    return [
      {
        headerName: 'Rebalance Name',
        field: 'analysisName',
        valueGetter: this.displayRebalanceName,
        minWidth: 170,
        comparator: this.util.sortString.bind(parent),
        suppressMovable: true
      },
      {
        headerName: 'Rebalance ID',
        field: 'rbRsltId',
        valueGetter: this.displayRebalanceID,
        minWidth: 100,
        cellRenderer: 'cellRendererFormatter',
        cellRendererParams: {
          link: (params: any) => {
            return params.value !== null;
          },
          onClick: (params: any) => {
            parent.showPortfolioResultDetail(params);
          },
        },
      },
      {
        headerName: 'Type',
        field: 'analysisTypeDesc',
        valueGetter: this.displayRebalanceType,
        minWidth: 100,
        comparator: this.util.sortString.bind(parent),
        cellRenderer: "TruncateTooltipCellComponent"
      },
      {
        headerName: 'Completed On',
        field: 'completionDate',
        valueGetter: this.displayRebalanceCompletedOn,
        minWidth: 160,
        comparator: this.util.sortString.bind(parent),
        cellRenderer: "TruncateTooltipCellComponent"
      },
      {
        headerName: 'Orders',
        field: 'ordersTotal',
        valueGetter: this.displayNumberOfTrades,
        minWidth: 80,
        cellClass: 'irb-cell-content-right',
        //comparator: this.util.sortString.bind(parent),
        cellRenderer: "TruncateTooltipCellComponent"
      },
      {
        headerName: 'Status',
        field: 'outcome',
        valueGetter: this.displayStatus,
        minWidth: 100,
        resizable: true,
        sortable: false,
        cellRenderer: "TruncateTooltipCellComponent",
        cellStyle: {borderRight:'none'}
      },
      {
        field: "createdOn",
        hide: true,
        sort: 'desc',
        suppressColumnsToolPanel: true
      }];

  }
  //this function does not change time/date when converting from different time zone to ET.
  // It just puts a correct time zone, so January 1st selected somewhere in Asia (GMT+0900) will be the same January 1st in New York (GMT-0400/GMT-0500)
  convertDateToET(dateChange: any) {
    let monthDate = dateChange.getMonth() + 1;
    monthDate = monthDate < 10 ? '0' + monthDate : monthDate;
    let dateDate = dateChange.getDate();
    dateDate = dateDate < 10 ? '0' + dateDate : dateDate;
    let offset = (new Date(dateChange.getFullYear() +'-' + monthDate + '-' + dateDate +' 06:00:00 GMT'))
      .toLocaleString('en-US',{timeZone:'America/New_York',hour:'2-digit', hour12: false});
    let time = '00:00:00';
    if (offset === '02') { offset = 'GMT-0400'; time = '08:00:00'}
    if (offset === '01') { offset = 'GMT-0500'; time = '07:00:00'}
    const dCreated = monthDate + '/' + dateDate + '/' + dateChange.getFullYear() + ' '+ time +' ' + offset;
    return dCreated;
  }
  convertYearMonthDateStringToET(dateChange: string) {
    if (!dateChange || !(typeof dateChange == 'string') || dateChange.length < 10) {
      return '';
    }
    let dateFullYear = dateChange.substring(0,4);
    let monthDate = dateChange.substring(5,7);
    let dateDate = dateChange.substring(8,10);
    let offset = (new Date(dateFullYear +'-' + monthDate + '-' + dateDate +' 06:00:00 GMT'))
      .toLocaleString('en-US',{timeZone:'America/New_York',hour:'2-digit', hour12: false});
    if (offset === '02') { offset = 'GMT-0400';}
    if (offset === '01') { offset = 'GMT-0500';}
    const dCreated = monthDate + '/' + dateDate + '/' + dateFullYear + ' 00:00:00 ' + offset;
    return dCreated;
  }
  convertDateAndTimeToET(d: any) {
    let retVal='';
    if (d) {
      try {
        retVal = new Date(d).toLocaleString('en-US',
          {
            timeZone: 'America/New_York', month: '2-digit', day: '2-digit', year: 'numeric',
            hour: 'numeric', minute: '2-digit'
          }).replace(',', '') + ' ET';
      } catch (e: any) {
        retVal = '';
      }
    }
    return retVal;
  }
  //converts date and time to ET, returns string in format 'yyyy-MM-ddThh:mm:ss GMT-0500'
  /* commented for future use
  convertDateTimeToET(dateChange: any) {
    let localDate = dateChange.toLocaleDateString('en-US',{timeZone:'America/New_York', month:'2-digit', day:'2-digit', year: 'numeric'});
    let monthDate = localDate.substring(0,2);
    let dateDate = localDate.substring(3,5);
    let dateFullYear = localDate.substring(6,10);
    dateDate = dateDate < 10 ? '0' + dateDate : dateDate;
    let offset = (new Date(dateFullYear +'-' + monthDate + '-' + dateDate +' 06:00:00 GMT'))
      .toLocaleString('en-US',{timeZone:'America/New_York',hour:'2-digit', hour12: false});
    if (offset === '02') { offset = 'GMT-0400';}
    if (offset === '01') { offset = 'GMT-0500';}
    const timeString = dateChange.toLocaleTimeString('en-US',{timeZone:'America/New_York', hour12: false});
    const dCreated = dateFullYear +'-'+ monthDate + '-' + dateDate + 'T'+ timeString +' ' + offset;
    return dCreated;
  }
  */

  //converts date and time to ET, and adds offset as '+00:00'
  convertDateTimeToETforInsert(dateChange: any) {
    let localDate = dateChange.toLocaleDateString('en-US',{timeZone:'America/New_York', month:'2-digit', day:'2-digit', year: 'numeric'});
    let monthDate = localDate.substring(0,2);
    let dateDate = localDate.substring(3,5);
    let dateFullYear = localDate.substring(6,10);
    let offset = '+00:00';
    //const timeString = dateChange.toLocaleTimeString('en-US',{timeZone:'America/New_York', hour12: false});
    const timeString = '12:00:00';
    const dCreated = dateFullYear +'-'+ monthDate + '-' + dateDate + 'T'+ timeString +'.000' + offset;
    return dCreated;
  }

  getRebalanceTypeListObject(isTlhWsaEnabled: boolean, isTLHSetInGlobal: boolean, ENABLE_TLH_FR: boolean, isCashUpfront: boolean) {
    const rebalanceTypeList: any = [
      {
        label: 'Full rebalance', 'value': '1', disableSubmit: false,
        disableEditParameters: false,
        glabel: 'Full rebalance', 'gvalue': 'FULL_REBALANCE', groupSeparater: true, disableContinue: false,
        customToolTipWhenDisabled: isCashUpfront ?
          'This Portfolio contains account with Cash Up Front or Settled Cash Up Front restriction. Only Cash management rebalance types can be automated.'
          : null,
        class: [isCashUpfront ? 'grid-cell-disabled' : null],
        notClickableItem: isCashUpfront
      },

      {
        'label': 'Generate and/or invest cash', 'value': '2', disableSubmit: false, disableEditParameters:
          false,
        glabel: 'Generate invest', gvalue: 'GENERATE_INVEST', disableContinue: false
      },
      {
        'label': 'Generate cash only', 'value': '3', disableSubmit: false, disableEditParameters: false,
        glabel: 'Generate cash only', gvalue: 'GENERATE_CASH', disableContinue: false
      },
      {
        'label': 'Invest cash only', 'value': '4', disableSubmit: false, disableEditParameters: false,
        glabel: 'Manage cash only', gvalue: 'INVEST_CASH', groupSeparater: true, disableContinue: false
      }];
    if (isTlhWsaEnabled && ENABLE_TLH_FR) {
      rebalanceTypeList.push({
        label: "Tax Loss Harvest and Full Rebalance",
        value: "7",
        disableSubmit: false,
        disableEditParameters: false,
        glabel: "TLH FULL REBALANCE",
        gvalue: "TLH_FULL_REBALANCE",
        groupSeparater: true,
        disableContinue: false,
        customToolTipWhenDisabled: isTLHSetInGlobal ?
          isCashUpfront ?
            'This Portfolio contains account with Cash Up Front or Settled Cash Up Front restriction. Only Cash management rebalance types can be automated.'
            : null
          : 'Tax loss harvest settings must be configured from iRebal settings before you may select this type',
        class: [(isTLHSetInGlobal && !isCashUpfront) ? null : 'grid-cell-disabled'],
        notClickableItem: !isTLHSetInGlobal || isCashUpfront
      });
    }
    return rebalanceTypeList;
  }
}
